/** One live header registration, not a cache of documents or page permissions.
 * Leases keep a departing route's cleanup from erasing the next route's header. */
export function createWorkspaceDocumentFrameStore<T>() {
  type Registration = { lease: object; pageId: string; value: T };
  let current: Registration | null = null;
  const listeners = new Set<() => void>();
  return {
    getSnapshot: () => current,
    subscribe(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; },
    publish(lease: object, pageId: string, value: T, routeId: string | null) {
      if (pageId !== routeId) return;
      current = { lease, pageId, value };
      for (const listener of listeners) listener();
    },
    release(lease: object) {
      if (current?.lease !== lease) return;
      current = null;
      for (const listener of listeners) listener();
    },
  };
}
